import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M13.92 3a7.08 7.08 0 100 14.16 7.08 7.08 0 000-14.16zm-8.28 7.08a8.28 8.28 0 112.92 6.312l-5.74 5.636-.84-.856 5.724-5.622a8.25 8.25 0 01-2.064-5.47z" fill="currentcolor" /></svg>;